var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v900H0V0h1440Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "google_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.364 0 5.84 3.346a7.56 7.56 0 0 0-.4 2.413c.001.817.135 1.63.395 2.404l-4.474 3.351A12.767 12.767 0 0 1 0 5.76C-.003 3.76.464 1.787 1.364 0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "google_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.94 0c3.385 0 6.408 1.24 8.766 3.25l-3.87 3.781a7.798 7.798 0 0 0-4.897-1.713c-3.49 0-6.43 2.204-7.46 5.269L0 7.24C2.164 2.94 6.682 0 11.94 0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "google_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.476 0c1.032 3.065 3.972 5.268 7.463 5.268 1.708 0 3.218-.397 4.417-1.136l4.25 3.215c-2.326 2.113-5.423 3.24-8.667 3.24-5.258 0-9.776-2.942-11.939-7.24Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "google_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.396 0c.18.768.302 1.595.302 2.363 0 4.238-1.588 7.542-4.03 9.76l-4.25-3.215c1.39-.856 2.36-2.173 2.717-3.885H0V0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google_svg__a)",
    transform: "translate(-456 -491)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google_svg__b)",
    transform: "translate(459 501.24)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M0 0h5.84v11.514H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google_svg__c)",
    transform: "translate(460.364 494)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EA4334",
    d: "M0 0h20.706v10.587H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google_svg__d)",
    transform: "translate(460.364 509.413)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M0 0h20.606v10.587H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google_svg__e)",
    transform: "translate(472.302 504.637)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4185F3",
    d: "M0 0h12.698v12.124H0V0z"
  })))));
};
export default SvgGoogle;